"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigContext = exports.DEFAULT_MOBILE_WIDTH = exports.DEFAULT_CLASS_PREFIX = void 0;
var react_1 = require("react");
exports.DEFAULT_CLASS_PREFIX = 'intl';
exports.DEFAULT_MOBILE_WIDTH = 768;
exports.ConfigContext = (0, react_1.createContext)({
    classPrefix: exports.DEFAULT_CLASS_PREFIX,
    mobileWidth: exports.DEFAULT_MOBILE_WIDTH,
});
//# sourceMappingURL=ConfigContext.js.map